module.exports = __webpack_public_path__ + "static/zeit-d07af1666f866febf10a753c801f3673.png";